import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";

export const getVenues = createAsyncThunk('venueSummary/getVenues',
  async () => {
    const response: AxiosResponse = await instance.get('v1/venues')
    return response.data
  })
